export enum FlexDirectionBreak {
  p1212 = '12/12',
  p1112 = '11/12',
  p1012 = '10/12',
  p912 = '9/12',
  p812 = '8/12',
  p712 = '7/12',
  p612 = '6/12',
  p512 = '5/12',
  p412 = '4/12',
  p312 = '3/12',
  p212 = '2/12',
  p112 = '1/12',
}
